import { useRouteData } from "@bcm-dev/bcms-vite";
import UITextInput from "compid/ui/UITextInput";
import React, { useEffect } from "react";
import { SVGAsset } from "res";
import BillerDropdown from "../BillerDropdown";
export default function BillerDropdownView(props) {
    const placeholderText = props.placeholderText ?? "";
    const { open, close, setValue, state,clear,set } = props.controllers;
    const  route  = useRouteData()
    const routeData = route !== null ? route.route : {};
    // Get the default data for the workflow
   const dataPoint =props.dataPoint;
   
    const inputRef = React.useRef();
    const onChange = value => {
        
     

        if(props.onChange instanceof Function) {
            set({value:value,dropdown:value.length >0})
        }
    }
const clearClick = evt => {
    clear();
}

    document.addEventListener("force-biller-search-state", evt => {
        const { value, showDropdown } = evt.detail.state;
     
        if(showDropdown =="true"){
            set({value:value??state.value,dropdown:true})
        }
        if(showDropdown =="false"){
            set({value:value??state.value,dropdown:false})
        }
        if(value){
            set({value:value,dropdown:showDropdown!==undefined ?showDropdown=="true":value.length >0})
        }      
    });

    useEffect(()=>{
        if(state.value == ""){
            if(routeData && routeData.name){
              setValue(routeData.name);
              if(props.onChange instanceof Function) {
                  props.onChange(routeData.name);
              }
            } 
          }
    },[])
   
    return (
        <div className={ `form-row flex-height ${ props.inputName } biller-search-field` }>
            <div className="dropdown-content">
                <div className="floating-label-input-container">
                   
                    <UITextInput className="floating-label-input form-row-input" onChange={ onChange } placeHolder={ placeholderText }  value={ state.value }  ref={ inputRef }  onKeyUp={ open } dataPoint={dataPoint} />

                    { !state.value &&<SVGAsset id="MagnifyingGlassIcon" /> }
                   { state.value &&<SVGAsset id="CloseIcon" onClick={clearClick} />}
                
                </div>

                { state.dropdown &&  <BillerDropdown controllers={ props.controllers } onChange={ props.onChange } /> }
            </div>

            { state.dropdown && <div className="dropdown-overlay" onClick={ close }></div> }
        </div>
    );
}